import type { ImageBase64, ImageBigBase64 } from '@shared/products-types';

const BASE64_URL_PREFIX = 'data:image/png;base64,';

export const prefixImageData = (
    imageBase64: ImageBase64,
    imageBigBase64: ImageBigBase64,
): string | undefined => {
    const image = imageBase64 || imageBigBase64;
    if (!image) {
        return undefined;
    }

    return `${BASE64_URL_PREFIX}${image}`;
};

export function isImageDataWithPrefix(imageBase64: ImageBase64): boolean {
    return !!imageBase64?.startsWith(BASE64_URL_PREFIX);
}
